import { openExternalSafely } from './policies';
import { getAuthState } from '../../../src/services/supabase/auth';
import { t, uiLanguage } from '../../../src/services/language';
import { WEB_CONFIG } from '../config';

/** `support.ts`'nin web karşılığı — işletim sistemi yerine tarayıcı bilgisi. */

export const SUPPORT_EMAIL = 'destek@talknote.net';

function clean(value: string | undefined): string {
  // eslint-disable-next-line no-control-regex
  return (value ?? '').replace(/[\u0000-\u001F\u007F]+/g, ' ').trim().slice(0, 200);
}

export async function contactSupport(): Promise<{ email: string; opened: boolean }> {
  await navigator.clipboard?.writeText(SUPPORT_EMAIL).catch(() => {});

  const auth = await getAuthState().catch(() => null);
  const user = auth?.signedIn ? auth.user : undefined;

  const details = [
    user && `${t('Ad', 'Name')}: ${clean(user.name)}`,
    user && `${t('E-posta', 'Email')}: ${clean(user.email)}`,
    user && `Plan: ${clean(user.plan)}`,
    user && `${t('Hesap kimliği', 'Account ID')}: ${clean(user.id)}`,
    `${t('Uygulama', 'App')}: TalkNote Web ${WEB_CONFIG.version}`,
    `${t('Tarayıcı', 'Browser')}: ${clean(navigator.userAgent)}`,
    `${t('Arayüz dili', 'Interface language')}: ${uiLanguage()}`,
  ].filter(Boolean);

  const body = [
    t('Merhaba TalkNote ekibi,', 'Hi TalkNote team,'),
    '',
    '',
    '',
    '———',
    t('Hesap bilgileri (destek için; istersen silebilirsin):', 'Account details (for support; feel free to remove):'),
    ...details,
  ].join('\r\n');

  const subject = t('TalkNote destek talebi', 'TalkNote support request');
  const url = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return { email: SUPPORT_EMAIL, opened: openExternalSafely(url) };
}
